import { render, staticRenderFns } from "./SectionData.vue?vue&type=template&id=523d6c17&scoped=true&"
import script from "./SectionData.vue?vue&type=script&lang=ts&"
export * from "./SectionData.vue?vue&type=script&lang=ts&"
import style0 from "./SectionData.vue?vue&type=style&index=0&id=523d6c17&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d6c17",
  null
  
)

export default component.exports